"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class MasterAccountHeldFee extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "MasterAccountHeldFee";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/plan-types"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create plan types.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/plan-types/" +
      this.code
    );
  }

  getAdminPath() {
    console.error("Cannot go to a plan type.");
  }

  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line subtitle)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default MasterAccountHeldFee;
